module.exports = "/_next/static/images/our-services-9bcfa20c227cc8ee7268e4ae19aefbe6.jpg.webp";